import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = `/tools`;

export const fetchToolsName = async (assistantId) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/name/assistant/${assistantId}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const fetchTools = async (assistantId) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/assistant/${assistantId}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const fetchToolById = async (uuid) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/itemId/${uuid}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const createTool = async (assistantId, toolData) => {
  console.log("🚀 ~ createTool ~ tool:", toolData);
  console.log("🚀 ~ createTool ~ assistantId:", assistantId);
  const res = await axiosInstance.post(
    `${BASE_URL}/create`,
    { assistantId, toolData },
    getAuthHeaders(),
  );
  return res.data;
};

export const updateTool = async (uuid, tool) => {
  const res = await axiosInstance.put(
    `${BASE_URL}/itemId/${uuid}`,
    tool,
    getAuthHeaders(),
  );
  return res.data;
};

export const deleteTool = async (uuid) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/itemId/${uuid}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const updateToolStatus = async (data) => {
  const res = await axiosInstance.put(
    `${BASE_URL}/update-status`,
    data,
    getAuthHeaders(),
  );
  return res.data;
};

export const createToolFromImage = async (assistantId, files) => {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append("files", file);
  });

  formData.append("assistantId", assistantId);

  const headers = {
    ...getAuthHeaders(),
    headers: {
      ...getAuthHeaders().headers,
      "Content-Type": "multipart/form-data",
    },
  };

  const res = await axiosInstance.post(
    `${BASE_URL}/create-from-image`,
    formData,
    headers,
  );
  return res.data;
};

